import React from 'react';
import { Box, Typography } from '@mui/material';
import type { ListBlock } from '../../../types/backend';

interface Props {
  block: ListBlock;
}

const ListBlockView: React.FC<Props> = ({ block }) => (
  <Box
    component={block.ordered ? 'ol' : 'ul'}
    sx={{
      my: 1,
      pl: 3,
      display: 'flex',
      flexDirection: 'column',
      gap: 0.5,
      color: 'text.primary',
    }}
  >
    {block.items.map((item, i) => (
      <Typography key={i} component="li" variant="body2" sx={{ lineHeight: 1.6 }}>
        {typeof item === 'string' ? (
          item
        ) : (
          <>
            <Box component="strong" sx={{ fontWeight: 600 }}>
              {item.label}
            </Box>{' '}
            {item.text}
          </>
        )}
      </Typography>
    ))}
  </Box>
);

export default ListBlockView;
